import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IEndereco } from "app/types/IEndereco"
import clsx from "clsx"
import React, { useCallback } from "react"

const estilosBotoes = require("../../../estilos/botoes.module.scss").default
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

export type AbaEnderecosProps = {
  enderecos: IEndereco[]
  tipoPessoa: string // 441453
  somenteLeitura: boolean
  enderecosSelecionados: IEndereco[]
  exibirBotaoEditarEndereco: boolean
  exibirBotaoIncluirEndereco: boolean
  exibirBotaoExcluirEndereco: boolean
  habilitarExcluirEndereco: boolean
  corSelecionado?: string
  textoSelecionado?: string
  onIncluirEndereco: () => void
  onExcluirEndereco: (enderecos: IEndereco[]) => void
  onEditarEndereco: (endereco: IEndereco) => void
  onToggleEnderecoSelecionado: (enderecos: IEndereco) => void
}

export const AbaEnderecos = (props: AbaEnderecosProps) => {

  const handleToggleEndereco = useCallback((endereco: IEndereco) => {
    props.onToggleEnderecoSelecionado(endereco)
  }, [props.onToggleEnderecoSelecionado])

  const handleEditarEndereco = useCallback((endereco: IEndereco, e: React.MouseEvent) => {
    props.onEditarEndereco(endereco)
    e.stopPropagation()
  }, [props.onEditarEndereco])

  const buttonIncluir = (
    <button 
      className={clsx('no-global-button _p-3', estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVerde)}
      onClick={props.onIncluirEndereco}
      id="AbaEnderecos_BotaoIncluir"
      key="AbaEnderecos_BotaoIncluir"
    >
      <FontAwesomeIcon
        icon={faCirclePlus}
        color="#5ac93c"
        fontSize={20}
      />
      Incluir
    </button>
  )

  const buttonExcluir = (
    <button 
      className={clsx('no-global-button _p-3', estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVermelho)}
      disabled={!props.habilitarExcluirEndereco}
      id="AbaEnderecos_BotaoExcluir"
      key="AbaEnderecos_BotaoExcluir"
      onClick={() => props.onExcluirEndereco(props.enderecosSelecionados)}
    >
      <FontAwesomeIcon
        icon={faTimesCircle}
        color="#f25713"
        fontSize={20}
      />
      Excluir
    </button>
  )

  const headerTabelaEndereco = () => {
    const mapHeader = ["Classificações", "Endereço", "Número", "Complemento", "Bairro", "Cidade", "UF", "Cep", "Referência", ""]

    return mapHeader.map((nome, index) => (
      <th
        key={`AbaEnderecos_Header_${index}`}
        id={`AbaEnderecos_Header_${index}`}
      >
        {nome}
      </th>
    ))
  }

  const itensTabelaEndereco = (endereco: IEndereco, index: number) => (
    <React.Fragment key={`AbaEnderecos_Row_${endereco.Codigo}`}>
      <td key={`classificacoes_${endereco.Codigo}_${index}`} id={`classificacoes_${endereco.Codigo}_${index}`}>{endereco?.DescricaoClassificacoes}</td>
      <td key={`logradouro_${endereco.Codigo}_${index}`} id={`logradouro_${endereco.Codigo}_${index}`}>{endereco?.Logradouro?.toUpperCase()}</td>
      <td key={`numero_${endereco.Codigo}_${index}`} id={`numero_${endereco.Codigo}_${index}`}>{endereco?.Numero}</td>
      <td key={`complemento_${endereco.Codigo}_${index}`} id={`complemento_${endereco.Codigo}_${index}`}>{endereco?.Complemento?.toUpperCase()}</td>
      <td key={`bairro_${endereco.Codigo}_${index}`} id={`bairro_${endereco.Codigo}_${index}`}>{endereco?.Bairro?.toUpperCase()}</td>
      <td key={`cidade_${endereco.Codigo}_${index}`} id={`cidade_${endereco.Codigo}_${index}`}>{endereco?.NomeCidade?.toUpperCase()}</td>
      <td key={`uf_${endereco.Codigo}_${index}`} id={`uf_${endereco.Codigo}_${index}`}>{endereco?.SiglaUf?.toUpperCase()}</td>
      <td key={`cep_${endereco.Codigo}_${index}`} id={`cep_${endereco.Codigo}_${index}`}>{endereco?.Cep}</td>
      <td key={`referencia_${endereco.Codigo}_${index}`} id={`referencia_${endereco.Codigo}_${index}`}>{endereco?.Referencia}</td>
      <td key={`acoes_${endereco.Codigo}_${index}`} id={`acoes_${endereco.Codigo}_${index}`}>
        {props.exibirBotaoEditarEndereco && (
          <FontAwesomeIcon
            className="_m-1"
            id={`AbaEnderecosCliente_BotaoEditarEndereco_${endereco.Codigo}_${index}`}
            key={`AbaEnderecosCliente_BotaoEditarEndereco_${endereco.Codigo}_${index}`}
            title="Veja parâmetros:&#013;-Bloquear alteração do endereço de entrega do cliente (pessoa  jurídica) no orçamento&#013;-Bloqueia edição de endereço de cobrança no orçamento"
            icon={faPenToSquare}
            color="#3c8ac9"
            fontSize={20}
            onClick={(e) => handleEditarEndereco(endereco, e)}
          />
        )}
      </td>
    </React.Fragment>
  )

  const tabelaEndereco = () => (
    <table className={`_w-full ${estiloTabela.tabela}`}>
      <thead>
        <tr>
          {headerTabelaEndereco()}
        </tr>
      </thead>

      <tbody>
        {props.enderecos?.map((endereco, index) => (
          <tr
            key={`AbaEnderecos_row_${endereco.Codigo}_${index}`}
            id={`AbaEnderecos_row_${endereco.Codigo}_${index}`}
            className={props.enderecosSelecionados.includes(endereco) ? estiloTabela.linhaSelecionada : estiloTabela.linhaClicavel}
            style={props.enderecosSelecionados.includes(endereco) ? { backgroundColor: props.corSelecionado, color: props.textoSelecionado } : {}}
            onClick={() => props.onToggleEnderecoSelecionado(endereco)}
          >
            {itensTabelaEndereco(endereco, index)}
          </tr>
        ))}
      </tbody>
    </table>
  )

  return (
    <React.Fragment>
      <div className="_pt-5 _mb-2 _flex">
        {props.exibirBotaoIncluirEndereco && !props.somenteLeitura &&
          buttonIncluir
        }

        {props.exibirBotaoExcluirEndereco && !props.somenteLeitura &&
          buttonExcluir
        }
      </div>

      <div className={estiloTabela.containerRolavel}>
        {tabelaEndereco()}
      </div>
    </React.Fragment>
  )
}